import authService from './authService';

// Ce chemin suppose que votre backend tourne sur le même hôte et port que votre frontend (via proxy)
// ou que REACT_APP_API_URL est défini dans votre .env (ex: http://localhost:3001)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'; // Si REACT_APP_API_URL n'est pas défini, utiliser localhost:3001

export const fetchAdminUsers = async (apiKey) => {
  // Utiliser l'authentification JWT au lieu de la clé API
  const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/admin/users`);
  if (!response.ok) {
    // Tenter de lire le corps de la réponse même en cas d'erreur pour obtenir plus de détails
    let errorData = { error: `Erreur HTTP ${response.status}` }; // Fallback
    try {
        errorData = await response.json();
    } catch (e) {
        console.warn("Impossible de parser la réponse d'erreur en JSON.");
        const textError = await response.text(); // Lire comme texte si ce n'est pas du JSON
        errorData.htmlContent = textError; // Pour voir si c'est du HTML
    }
    console.error("Erreur lors de la récupération des utilisateurs:", errorData);
    throw new Error(errorData.error || errorData.message || `Erreur HTTP ${response.status}`);
  }
  return response.json();
};

export const applySignaturesBatch = async (apiKey, userEmails, signature) => {
  // Utiliser l'authentification JWT au lieu de la clé API
  const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/admin/signatures`, {
    method: 'POST',
    body: JSON.stringify({ userEmails, signature }),
  });
  if (!response.ok) {
    let errorData = { error: `Erreur HTTP ${response.status}` };
    try {
        errorData = await response.json();
    } catch (e) {
        console.warn("Impossible de parser la réponse d'erreur en JSON pour applySignaturesBatch.");
        const textError = await response.text();
        errorData.htmlContent = textError;
    }
    console.error("Erreur lors de l'application des signatures:", errorData);
    throw new Error(errorData.error || errorData.message || `Erreur HTTP ${response.status}`);
  }
  return response.json();
};

export const suspendUser = async (apiKey, userEmail) => {
  // Utiliser l'authentification JWT au lieu de la clé API
  const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/admin/users/${encodeURIComponent(userEmail)}/suspend`, {
    method: 'POST',
    // Pas de corps nécessaire pour cette requête POST spécifique, l'email est dans l'URL
  });
  if (!response.ok) {
    let errorData = { error: `Erreur HTTP ${response.status}` };
    try {
      errorData = await response.json();
    } catch (e) {
      console.warn(`Impossible de parser la réponse d'erreur en JSON pour suspendUser(${userEmail}).`);
      const textError = await response.text();
      errorData.htmlContent = textError;
    }
    console.error(`Erreur lors de la suspension de l'utilisateur ${userEmail}:`, errorData);
    throw new Error(errorData.error || errorData.message || `Erreur HTTP ${response.status}`);
  }
  return response.json();
}; 